import React, { useState, useCallback, useEffect, useMemo } from 'react';
import Pagination from '../../../components/Pagination';
import { getUsersAllList } from '../../../utils/apicall/usersApi';
import { Users } from '../../../utils/types';
import UserList from './userList';
import { authService } from '../../../utils/authServices';

const UserDashBoard: React.FC = () => {
  const [data, setData] = useState<Users[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>(''); // State for the search input
  const [currentPage, setCurrentPage] = useState(1);
  const itemPerPage = 15;
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);

  const loadData = useCallback(async () => {
    try {
      const response = await getUsersAllList();

      if (response) {
        setData(response);
      } else {
        console.warn('Expected an array but got:', response);
        setData([]); // Set an empty array to prevent undefined errors
      }
    } catch (error) {
      console.error('An error occurred while fetching data.', error);
      setData([]); // Set an empty array to handle the error case
    }
  }, []);

  useEffect(() => {
    loadData();
    authService.getTokenExpiration();
  }, [loadData]);

  // Apply search filter
  const filteredData = useMemo(() => {
    return Array.isArray(data)
      ? data.filter(item => item.name?.toLowerCase().includes(searchTerm.toLowerCase()))
      : [];
  }, [data, searchTerm]);

  // Sort logic
  const sortedData = useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        let aValue: any;
        let bValue: any;

        switch (sortConfig.key) {
          case 'name':
            aValue = a.name?.trim().toLowerCase() ?? '';
            bValue = b.name?.trim().toLowerCase() ?? '';
            break;
          default:
            return 0;
        }

        if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig]);

  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Handle search input change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Sorting functions
  const requestSort = (key: 'name') => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const totalPages = Math.ceil(sortedData.length / itemPerPage);

  // Determine title
  const title = 'Χρήστες';

  return (
    <div className="content">
      <div className="container py-5">
      <div className="row align-items-center">
          <div className="col-md-7">
            <h2 className="h4 text-primary fw-light py-3">{title}</h2>
          </div>
        </div>
        {/* Search and Sort Controls */}
        <div className="row align-items-center">
            {/* <!-- Search Input --> */}
            <div className="col-md-9 mb-4">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Αναζήτηση ..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
             </div>
          {/* Sort Buttons */}
          <div className="col-md-3 mb-4 text-md-end">
            <button onClick={() => requestSort('name')} className="btn btn-primary btn-sm mx-1">
              Ταξινόμηση/Όνομα
            </button>
          </div>
        </div>
        <div className="row">
                <div className="col-12">
                   <hr className="" style={{ borderColor: "#036EC5" }} />
                </div>
            </div>
            
        <div id="projectList">
          <UserList
            data={sortedData.slice((currentPage - 1) * itemPerPage, currentPage * itemPerPage) || []}
          />
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
    </div>
  );
};

export default UserDashBoard;
